module.exports = __webpack_public_path__ + "img/hanger.d3d24c91.png";